import { useEffect } from 'react';
import { recordConnectionReturn } from '@/workspace/connection-return-state';
import { useNamespaceCopy } from '@/i18n/ns';
import { entrySurfaceCopy } from '@/i18n/ns/entry-surfaces';

/** The provider return is not a chat or proof of authorization. The original
 * window stays where the user started and reconciles the account server-side. */
export function ConnectionReturn() {
  const copy = useNamespaceCopy(entrySurfaceCopy);
  const params = new URLSearchParams(location.search);
  const failed = params.get('connection') === 'failed';
  const attempt = params.get('attempt') ?? '';
  useEffect(() => {
    recordConnectionReturn(attempt, failed ? 'failed' : 'complete');
    history.replaceState(null, '', '/connection-return');
    window.close();
  }, [attempt, failed]);
  return (
    <main className="company-welcome-page">
      <div className="company-welcome-top">
        <span>poneva</span>
      </div>
      <section className="company-welcome-card">
        <h1>{failed ? copy.connectionFailed : copy.connectionChecking}</h1>
        <p>{failed ? copy.connectionFailedBody : copy.connectionCheckingBody}</p>
        <a className="company-primary" href="/#/workspace/connections">
          {copy.goConnections}
        </a>
      </section>
    </main>
  );
}
